import React from "react";
import { Link } from "react-router";
import { DailyIcon } from "@/features/daily/components/DailyIcon";
import type { PriorityRowVm } from "@/features/daily/components/command/today-view-model";

type Props = {
    rows: PriorityRowVm[];
    allHref: string;
    onOpen: (operationId: string, trigger: HTMLElement) => void;
};

/**
 * D134: the five operations to look at first. The whole row opens the app's detail
 * modal (D120); the id button is where focus returns when it closes.
 */
export const PriorityOperations: React.FC<Props> = ({ rows, allHref, onOpen }) => (
    <section className="daily-panel daily-priority" aria-labelledby="daily-priority-title">
        <div className="daily-panel__head">
            <h2 id="daily-priority-title">Operaciones prioritarias</h2>
            <Link className="daily-link" to={allHref}>Ver todas <DailyIcon name="arrow_forward" /></Link>
        </div>
        {rows.length === 0 ? (
            <p className="daily-small daily-muted">Nada que mirar primero ahora mismo.</p>
        ) : (
            <div className="daily-table__scroll daily-priority__scroll" role="region" aria-label="Operaciones prioritarias, lista desplazable" tabIndex={0}>
                <table className="daily-table daily-priority__table">
                    <caption className="daily-visually-hidden">Operaciones prioritarias de hoy</caption>
                    <thead className="daily-table__head--sticky">
                        <tr>
                            <th scope="col">Creada</th>
                            <th scope="col">ID de operación</th>
                            <th scope="col">Correo</th>
                            <th scope="col">Estado</th>
                            <th scope="col">Etapa</th>
                            <th scope="col" className="is-numeric">Edad</th>
                            <th scope="col" className="is-numeric">Importe</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map(({ row, sourceLabel }) => (
                            <tr
                                key={row.operationId}
                                className="daily-row-clickable"
                                onClick={(event) => {
                                    const opener = event.currentTarget.querySelector<HTMLElement>("[data-row-open]");
                                    if (opener !== null) onOpen(row.operationId, opener);
                                }}
                            >
                                <td>{row.createdLabel}</td>
                                <td>
                                    <button
                                        type="button"
                                        className="daily-link daily-mono"
                                        data-row-open=""
                                        aria-label={`Ver detalle de ${row.operationId}`}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            onOpen(row.operationId, event.currentTarget);
                                        }}
                                    >
                                        {row.operationId}
                                    </button>
                                </td>
                                <td>{row.accountEmail === null ? <span className="daily-muted">Sin correo registrado</span> : row.accountEmail}</td>
                                <td><span className="daily-pill" data-tone={row.statusTone} title={sourceLabel === null ? row.stateLabel : `${sourceLabel} · ${row.stateLabel}`}>{row.statusLabel}</span></td>
                                <td>{row.stageLabel}</td>
                                <td className="is-numeric">{row.ageLabel}</td>
                                <td className="is-numeric">{row.amountLabel}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )}
    </section>
);
